"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getActionClauseTypeOptions() {
    //******** MUST READ ********//
    // Must keep in order by dropdown section!
    return [
        // Organize
        'moveTo',
        'copyTo',
        'delete',
        'pin',
        // Mark message
        'read',
        'junk',
        'markImportance',
        // Route
        'forwardTo',
        'forwardAsAttachmentTo',
        'redirectTo',
    ];
}
exports.default = getActionClauseTypeOptions;
//# sourceMappingURL=getActionClauseTypeOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/getActionClauseTypeOptions.js
// module id = 2795
// module chunks = 2 90